import {
  useGetCommunicationTemplatesQuery,
  useGetFilteredCustomersMutation,
  useSendCommunicationMutation,
  useSendPremiumCommunicationMutation,
  useGetBatchStatusQuery,
  useSaveCommunicationScheduleMutation,
  useGetCommunicationScheduleQuery,
  useDeleteCommunicationScheduleMutation,
  useSaveAllScheduleApiMutation,
  useGetCommunicationLogsQuery,
} from '../../baseApi';

/**
 * Hook to fetch communication templates with optional filters.
 */
export const useCommunicationTemplates = (args = {}) => {
  return useGetCommunicationTemplatesQuery(args, {
    refetchOnMountOrArgChange: true,
  });
};

/**
 * Hook bundle for communication operations (filtering and sending).
 */
export const useCommunicationOperations = () => {
  const [getFilteredCustomers, { isLoading: filtering }] = useGetFilteredCustomersMutation();
  const [sendCommunication, { isLoading: sending }] = useSendCommunicationMutation();
  const [sendPremiumCommunication, { isLoading: sendingPremium }] = useSendPremiumCommunicationMutation();

  return {
    getFilteredCustomers,
    sendCommunication,
    sendPremiumCommunication,
    isProcessing: filtering || sending || sendingPremium,
  };
};

/**
 * Hook to fetch the current communication schedule.
 */
export const useCommunicationSchedule = () => {
  return useGetCommunicationScheduleQuery();
};

/**
 * Hook bundle for scheduling operations.
 */
export const useScheduleOperations = () => {
  const [saveSchedule, { isLoading: saving }] = useSaveCommunicationScheduleMutation();
  const [deleteSchedule, { isLoading: deleting }] = useDeleteCommunicationScheduleMutation();
  const [saveAllSchedule, { isLoading: savingAll }] = useSaveAllScheduleApiMutation();

  return {
    saveSchedule,
    deleteSchedule,
    saveAllSchedule,
    isProcessing: saving || deleting || savingAll,
  };
};

/**
 * Hook to fetch communication logs with parameters.
 */
export const useCommunicationLogs = (params = {}) => {
  return useGetCommunicationLogsQuery(params, {
    refetchOnMountOrArgChange: true,
  });
};

/**
 * Hook to check the status of a specific batch.
 */
export const useBatchStatus = (batchId) => {
  return useGetBatchStatusQuery(batchId, { skip: !batchId });
};
